import type { Theme } from '@theme-ui/css';
import { PartnerId } from '@hc-claims/utilities';

import { theme as defaultTheme } from '../themes/default';
import { theme as travixBudgetAirTheme } from '../themes/travixBudgetAir';
import { theme as travixCheaptickets } from '../themes/travixCheaptickets';
import { theme as travixFlugladen } from '../themes/travixFlugladen';
import { theme as travixVayama } from '../themes/travixVayama';
import { theme as travixVliegwinkel } from '../themes/travixVliegwinkel';

export const getTheme = (partnerId?: PartnerId): Theme => {
  switch (partnerId) {
    case PartnerId.TRAVIX_BUDGET_AIR:
      return travixBudgetAirTheme;
    case PartnerId.TRAVIX_CHEAPTICKETS:
      return travixCheaptickets;
    case PartnerId.TRAVIX_FLUGLADEN:
      return travixFlugladen;
    case PartnerId.TRAVIX_VAYAMA:
      return travixVayama;
    case PartnerId.TRAVIX_VLIEGWINKEL:
      return travixVliegwinkel;
    default:
      return defaultTheme;
  }
};
